import { gql } from "apollo-boost";

export const CONTACT = gql`
  query GetContacts {
    contacts {
      id
      first
      middle
      last
      age
      country
      ethnicity
      year
      month
      source
      facebook
    }
  }
`;

export const COUNT = gql`
  query GetCount {
    count
  }
`;

export const SOURCE = gql`
  query GetSources {
    sources
  }
`;

export const YEAR = gql`
  query GetYears {
    years
  }
`;

export const AVERAGE = gql`
  query GetAverage {
    average
  }
`;

export const COUNTRY = gql`
  query GetCountries {
    countries
  }
`;

export const ETHNICITY = gql`
  query GetEthnicities {
    ethnicities
  }
`;
